import produce from "immer";

import {
  VARIANTS_INFO,
  VARIANT_CREATE_SUCCESS,
  VARIANT_CREATE_FAILURE,
  VARIANT_UPDATE_SUCCESS
} from "src/actions/mgmtVariantAction";

const initialState = {

  variants: [],

  variantInfo: []

};

const variantReducer = (
  state = initialState,
  action
) => {

  switch (action.type) {

    // Loading
    case VARIANTS_INFO: {

      return produce(state, (draft) => {

        draft.variants = [];

      });

    }

    // Get Variants
    case VARIANT_CREATE_SUCCESS: {

      const { variants } = action.payload;

      return produce(state, (draft) => {

        draft.variants = variants;

      });

    }

    // Update Variant
    case VARIANT_UPDATE_SUCCESS: {

      const { variant } = action.payload;

      return produce(state, (draft) => {

        draft.variantInfo = variant;

      });

    }

    // Failure
    case VARIANT_CREATE_FAILURE: {

      return produce(state, () => {

        console.log("Variant API Failed");

      });

    }

    default: {

      return state;

    }
  }
};

export default variantReducer;